import http from 'hub-http/clients/apiClient';
const BASE_URL = 'permissions-skynet/v1';
export default {
  fetchUsersByScope: scope => http.get(`${BASE_URL}/scopes/app/${scope}/hub-users`)
};